const initBlock = function( $block ) {
	const $programs = $block.find( '.program' );
	if ( !$programs.length ) { return false; }
	$programs.each( function() {
		const $program = $( this );
		const $marqueeTrackInner = $program.find( '.program__marquee-track-inner' );
		const $originalSpan = $marqueeTrackInner.find( 'span' ).first();
		for ( let i = 0; i < 46; i++ ) {
			$marqueeTrackInner.append( $originalSpan.clone() );
		}
	} );

	const $button = $block.find( '.section-pricing__button' );
	if ( $button.length > 0 ) {
		const $buttonLabel = $button.find( '.ml-button__label' );
		const html = $buttonLabel.html();
		const newHtml = html.replace( /\b(us)\b/i, '<span class="mobile-hidden">$1</span>' );
		$buttonLabel.html( newHtml );
	}

	function slugify( text ) {
		return text
			.toString()
			.toLowerCase()
			.trim()
			.replace( /[\s_]+/g, '-' )
			.replace( /[^\w-]+/g, '' );
	}

	$( '#modal-contact-us' ).on( 'show.bs.modal', function( event ) {
		const triggerBtn = event.relatedTarget?.btn;
		const $checkboxes = $( event.currentTarget ).find( '.js-services input[type="checkbox"]' );

		$checkboxes.prop( 'checked', false ).trigger( 'change' );
		$checkboxes.off( 'click.pricing' );
		$checkboxes.each( function() {
			$( 'label[for="' + $( this ).attr( 'id' ) + '"]' ).removeClass( 'read-only' );
		} );

		if ( triggerBtn && $( triggerBtn ).data( 'included-services' ) ) {
			const included = $( triggerBtn ).data( 'included-services' );
			const includedArr = included ? included.split( ',' ) : [];

			$checkboxes.on( 'click.pricing', function( e ) {
				e.preventDefault();
				return false;
			} );

			$checkboxes.each( function() {
				$( 'label[for="' + $( this ).attr( 'id' ) + '"]' ).addClass( 'read-only' );
			} );

			$checkboxes.each( function() {
				const $checkbox = $( this );
				const value = $checkbox.val();
				const valueSlug = slugify( value );

				if ( includedArr.includes( valueSlug ) ) {
					$checkbox.prop( 'checked', true ).trigger( 'change' );
				}
			} );
		} else {
			$checkboxes.prop( 'checked', false ).trigger( 'change' );
		}
	} );

	$( '#modal-contact-us' ).on( 'hidden.bs.modal', function() {
		const $checkboxes = $( '#modal-contact-us .js-services input[type="checkbox"]' );
		$checkboxes.prop( 'checked', false ).trigger( 'change' );
		$checkboxes.prop( 'disabled', false );
	} );
};

app.loadBlock( initBlock, 'section-pricing', '.section-pricing' );

if ( module.hot ) {
	module.hot.accept();
}
